import { configureStore } from "@reduxjs/toolkit";
import AppData from "./AppData";
import SearchCards from './SearchCards'
import BoardsData from './BoardsData'
import RoadmapSlice from './RoadmapSlice'
const store = configureStore({
  reducer: {
    userId: AppData,
    searchCards: SearchCards,
    BoardsData: BoardsData,
    RoadmapSlice: RoadmapSlice

  }
})

export default store;